import { ColumnDef } from '@tanstack/react-table';

import { BalanceHistoryItem } from '@/features/slice/balance-history/balance-history.schema';
import { formatCurrencyInBDT } from '@/utils';
import { DateFormatter } from '@/utils/date-formatter.util';

// import { EditBalanceDialog } from './edit-balance-dialog.component';

export const cashBoxColumns: ColumnDef<BalanceHistoryItem>[] = [
    {
        accessorKey: 'date',
        header: () => <div>Date</div>,
        cell: ({ row }) => (
            <div className="font-medium">
                {DateFormatter.formatDate(row.original.date)}
            </div>
        ),
    },
    // {
    //     accessorKey: 'user_name',
    //     header: () => <div>User</div>,
    //     cell: ({ row }) => (
    //         <div className="font-medium">
    //             {row.original.user_name || 'System'}
    //         </div>
    //     ),
    // },
    {
        accessorKey: 'starting_balance',
        header: () => <div className="text-right">Starting Balance</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {formatCurrencyInBDT(
                    Number(row.original.starting_balance || 0),
                )}
            </div>
        ),
    },
    {
        accessorKey: 'ending_balance',
        header: () => <div className="text-right">Ending Balance</div>,
        cell: ({ row }) => (
            <div className="text-right">
                {row.original.ending_balance == null
                    ? 'N/A'
                    : formatCurrencyInBDT(Number(row.original.ending_balance))}
            </div>
        ),
    },
    // {
    //     accessorKey: 'note',
    //     header: () => <div>Note</div>,
    //     cell: ({ row }) => <div>{row.original.note || '—'}</div>,
    // },
    // {
    //     accessorKey: 'action',
    //     header: () => <div className="text-right">Action</div>,
    //     cell: ({ row }) => (
    //         <div className="flex justify-end">
    //             <EditBalanceDialog row={row.original} />
    //         </div>
    //     ),
    // },
];
